import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

@Component({
  selector: 'kt-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => DatePickerComponent), multi: true }]
})
export class DatePickerComponent implements ControlValueAccessor {
  @Input() label = '';
  /** When set, clamps the label to this many lines and reserves that height, so labels of
   * differing length stay vertically aligned across a row of fields. Unset = natural height. */
  @Input() labelLines: number = null;
  @Input() placeholder = '';
  @Input() hint = '';
  @Input() errorMessage = '';
  @Input() disabled = false;
  @Input() required = false;
  @Input() minDate: Date | null = null;
  @Input() maxDate: Date | null = null;
  /** Calendar month to open at when no value is selected. */
  @Input() startAt: Date | null = null;
  /** Predicate to enable/disable individual dates (matDatepickerFilter); returns true for selectable dates. */
  @Input() dateFilter: (date: Date | null) => boolean = null;

  value: Date | null = null;

  onChange = (_: any) => { };
  onTouched = () => { };

  onDateChange(event: MatDatepickerInputEvent<Date>) {
    this.value = event.value;
    this.onChange(this.value);
    this.onTouched();
  }

  writeValue(value: any) { this.value = value ?? null; }
  registerOnChange(fn: any) { this.onChange = fn; }
  registerOnTouched(fn: any) { this.onTouched = fn; }
  setDisabledState(isDisabled: boolean) { this.disabled = isDisabled; }
}
